import ReactDOM from 'react-dom/client';
// import reportWebVitals from './reportWebVitals';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';

import { getApolloClient } from './graphql/client';
import { EntryRouting } from 'entry-routing';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
// NOTE: Can uncomment StrictMode when react-player bug is fixed - https://github.com/cookpete/react-player/pull/1538
root.render(
    // <React.StrictMode>
        <ApolloProvider client={getApolloClient()}>
            <BrowserRouter>
                <EntryRouting />
            </BrowserRouter>
        </ApolloProvider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
